import { isNil } from "lodash";

export const hasOverlap = (xA: number | null, yA: number | null, xB: number | null, yB: number | null) => {
	if ((isNil(xA) && isNil(yA)) || (isNil(xB) && isNil(yB))) {
		return false;
	}

	let startA = isNil(xA) ? -Infinity : xA;
	let endA = isNil(yA) ? Infinity : yA;
	let startB = isNil(xB) ? -Infinity : xB;
	let endB = isNil(yB) ? Infinity : yB;

	if (startA > startB) {
		[startA, endA, startB, endB] = [startB, endB, startA, endA];
	}

	if ((!isFinite(startA) && !isFinite(startB)) || (!isFinite(endA) && !isFinite(endB))) {
		return true;
	}

	return endA >= startB;
};
